<template>
  <div>
    <card class="card" title="Reports" :showFilter="false">
      <div class="ml-2 mb-5">
        <div class="row">
          <div class="mt-3 pl-5 col-lg-2 col-md-4 col-sm-12">Select report to run</div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <multiselect
              v-model="selectedReport"
              :options="reportList"
              placeholder="Select report"
              :showLabels="false"
            />
          </div>
        </div>
      </div>
    </card>
    <card
      class="card"
      title="Audit Results Report Parameters"
      subTitle="Specify parameters and click View:"
      :showFilter="false"
      v-show="selectedReport === 'Audit Results Report'"
    >
      <AuditReportParameters ref="AuditReportParameters" />
    </card>
    <card
      class="card"
      title="Single Asset Audit Report Parameters"
      subTitle="Specify parameters and click View:"
      :showFilter="false"
      v-show="selectedReport === 'Single Asset Audit Report'"
    >
      <SingleAssetAuditReportParameters ref="SingleAssetAuditReportParameters" />
    </card>
    <card
      class="card"
      title="Failed Audit Report Parameters"
      subTitle="Specify parameters and click View:"
      :showFilter="false"
      v-show="selectedReport === 'Failed Audit Report'"
    >
      <FailedAuditReportParameters ref="FailedAuditReportParameters" />
    </card>
    <card
      class="card"
      title="Asset Report Parameters"
      subTitle="No parameters needed, click View to generate the report"
      :showFilter="false"
      v-show="selectedReport === 'Asset Report'"
    >
      <AssetReportParameters ref="AssetReportParameters" />
    </card>

    <card
      class="card"
      title="Tag Report Parameters"
      subTitle="Specify parameters and click View:"
      :showFilter="false"
      v-show="selectedReport === 'Tag Report'"
    >
      <TagReportParameters ref="TagReportParameters" />

    </card>

	<card
      class="card"
      title="Progress Report Parameters"
      subTitle="No parameters needed, click View to generate the report"
      :showFilter="false"
      v-show="selectedReport === 'Progress Report'"
    >
      <ProgressReportParameters ref="ProgressReportParameters" />
    </card>
  </div>
</template>

<script>
import Vue from "vue";
import Multiselect from "vue-multiselect";
import jsreport from "jsreport-browser-client-dist";
import AuditReportParameters from "@/pages/Reports/AuditReportParameters.vue";
import SingleAssetAuditReportParameters from "@/pages/Reports/SingleAssetAuditReportParameters.vue";
import FailedAuditReportParameters from "@/pages/Reports/FailedAuditReportParameters.vue";
import AssetReportParameters from "@/pages/Reports/AssetReportParameters.vue";
import TagReportParameters from "@/pages/Reports/TagReportParameters.vue";
import ProgressReportParameters from "@/pages/Reports/ProgressReportParameters.vue";
import { db, getCustomer } from "@/db";
import utils from "@/utils";
import store from "@/router/store";
Vue.component("multiselect", Multiselect);

export default {
  components: {
    Multiselect,
    AuditReportParameters,
    SingleAssetAuditReportParameters,
    AssetReportParameters,
    TagReportParameters,
	FailedAuditReportParameters,
	ProgressReportParameters
  },
  data() {
    return {
      reportList: ["Audit Results Report", "Single Asset Audit Report", "Asset Report", "Tag Report", "Progress Report"],
      selectedReport: ""
    };
  },
  // mounted() {
  //   getCustomer()
  //     .collection("audits")
  //     .get()
  //     .then(snap => {
  //       console.log("retrieved audits: ", snap.size); // will return the collection size
  //     });
  // },
  methods: {}
};
</script>

<style scoped>
.card {
  z-index: auto;
}
</style>

<style>
.multiselect__option--selected.multiselect__option--highlight {
  background: #fffcf5;
  color: #f38e24;
}

.multiselect__option--highlight {
  background: #f38e24;
}

.multiselect__option--selected {
  background: #f3f3f3;
  color: #35495e;
}
</style>
